import { useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import { NomenclatureGroupInterval, ListResponse } from '@/types';
import { Pagination } from '@/components';
import { EditFlat, ExternalLinkOutlined, TrashFlat } from '@/assets/icons';
import theme from '@/theme';

import { DeleteNomenclatureGroupInterval, UpdateNomenclatureGroupInterval } from '../components';

export interface NomenclatureGroupIntervalListProps {
  list?: ListResponse<NomenclatureGroupInterval>;
  page: number;
  onChangePage(page: number): void;
}

const NomenclatureGroupIntervalsTable: React.FC<NomenclatureGroupIntervalListProps> = ({
  list,
  page,
  onChangePage,
}) => {
  const [updateModalOpened, setOpenedUpdateModal] = useState(false);
  const [deleteModalOpened, setOpenedDeleteModal] = useState(false);
  const [currentNomenclatureGroupInterval, setCurrentNomenclatureGroupInterval] =
    useState<NomenclatureGroupInterval | null>(null);

  function openUpdateModal(nomenclatureGroupInterval: NomenclatureGroupInterval) {
    setCurrentNomenclatureGroupInterval(nomenclatureGroupInterval);
    setOpenedUpdateModal(true);
  }

  function openDeleteModal(nomenclatureGroupInterval: NomenclatureGroupInterval) {
    setCurrentNomenclatureGroupInterval(nomenclatureGroupInterval);
    setOpenedDeleteModal(true);
  }

  return (
    <>
      <Stack spacing={3}>
        <TableContainer component={Paper} sx={{ maxHeight: `calc(100vh - ${theme.spacing(34.5)})` }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Наименование</TableCell>
                <TableCell>Сумма (мин.)</TableCell>
                <TableCell>Сумма (макс.)</TableCell>
                <TableCell>Ставки</TableCell>

                <TableCell />
              </TableRow>
            </TableHead>

            <TableBody>
              {list?.data.map((nomenclatureGroupInterval) => {
                const { name, sum_from, sum_to, id } = nomenclatureGroupInterval;

                return (
                  <TableRow key={id}>
                    <TableCell>{name}</TableCell>
                    <TableCell>{sum_from}</TableCell>
                    <TableCell>{sum_to}</TableCell>

                    <TableCell>
                      <Tooltip title="Ставки">
                        <IconButton
                          component={RouterLink}
                          to={`/dictionaries/intervals/${id}/rates`}
                          aria-label="Ставки"
                        >
                          <ExternalLinkOutlined sx={{ fontSize: 16 }} />
                        </IconButton>
                      </Tooltip>
                    </TableCell>

                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Обновить">
                          <IconButton aria-label="Обновить" onClick={() => openUpdateModal(nomenclatureGroupInterval)}>
                            <EditFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Удалить">
                          <IconButton aria-label="Удалить" onClick={() => openDeleteModal(nomenclatureGroupInterval)}>
                            <TrashFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          size="medium"
          count={list?.meta.last_page}
          page={page}
          boundaryCount={2}
          color="primary"
          shape="rounded"
          onChange={(event, value) => onChangePage(value)}
        />
      </Stack>

      <UpdateNomenclatureGroupInterval
        nomenclatureGroupInterval={currentNomenclatureGroupInterval!}
        open={updateModalOpened}
        onClose={() => setOpenedUpdateModal(false)}
      />
      <DeleteNomenclatureGroupInterval
        nomenclatureGroupInterval={currentNomenclatureGroupInterval!}
        open={deleteModalOpened}
        onClose={() => setOpenedDeleteModal(false)}
      />
    </>
  );
};

export default NomenclatureGroupIntervalsTable;
